const DEV_URL = 'http://localhost:8080/';
const PROD_URL = 'https://mydnd-370713.ts.r.appspot.com/';

export const API_URL = PROD_URL; //
